import styled from "styled-components";

export const AuthWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background-color: #15171c;
`;

export const AuthContainer = styled.div`
  border-radius: 25px;
  width: 370px;
  height: 580px;
  padding: 80px 0;
  background: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
`;
